export const NoBadMoodIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke={fill} strokeWidth="0.7" />
        <path
          d="M9 17C9.85038 16.3697 10.8846 16 12 16C13.1154 16 14.1496 16.3697 15 17"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
        <ellipse cx="15" cy="10.5" rx="1" ry="1.5" fill={fill} />
        <ellipse cx="9" cy="10.5" rx="1" ry="1.5" fill={fill} />
        <path
          d="M18.5 5.5L5.50002 18.4998"
          stroke="black"
          strokeWidth="0.7"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
